import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Container from '../../../components/Container';
import ClassLists from '../../Lists/ClassLists';
import ProjectLists from '../../Lists/ProjectLists';
import StudentLists from '../../Lists/StudentLists';
import EstablishmentLists from '../../Lists/EstablishmentLists';
import AdminLecturerLists from '../../Lists/AdminLecturerLists';
import BlockList from '../../../components/BlockList';
import ButtonReport from '../../../components/ButtonReport';
import getTodayDateAsString from '../../../utils/date';
import Tabs from '../../../components/Tabs';
import pageNames from '../../../utils/page_names';

export default function SuperAdminDashboard({ locales }) {
  const history = useHistory();
  const { userId } = useParams();
  const [currentUserId, setCurrentUserId] = useState(null);

  const {
    blocks: { collections },
    user,
  } = useSelector((state) => state);

  const {
    blocks: { fetchBlocks },
  } = useDispatch();

  useEffect(() => {
    if (currentUserId !== null) return;

    if (userId !== undefined) {
      setCurrentUserId(parseInt(userId));
    } else if (user?.current?.id !== undefined) {
      setCurrentUserId(user?.current?.id);
    }
  }, [userId, user]);

  useEffect(() => {
    fetchBlocks({ by: 'users', byId: userId, pageName: 'super_admin' });
  }, []);

  const downloadButtonParams = {
    href: `/admin/users?format=xlsx`,
    fileName: `users_${getTodayDateAsString()}.xlsx`,
  };

  const tabItems = [
    {
      name: locales.admin.establishment,
      component: (
        <EstablishmentLists
          rowClick={(record) =>
            history.push(`/admin/establishment/${record.id}`)
          }
          locales={locales}
          rowClickable
        />
      ),
    },
    {
      name: locales.admin.adminEducator,
      component: (
        <AdminLecturerLists
          locales={locales}
          byId={currentUserId}
          rowClick={(record) => {
            if (record.role !== 'super_admin')
              history.push(`/admin/lecturer/${record.id}`);
          }}
          rowClickable
        />
      ),
    },
    {
      name: locales.admin.class,
      component: (
        <ClassLists
          locales={locales}
          byId={currentUserId}
          rowClick={(record) => {
            history.push(`/admin/classroom/${record.id}`);
          }}
          rowClickable
          disableCreateClassroom
        />
      ),
    },
    {
      name: locales.admin.project,
      component: (
        <ProjectLists
          byId={currentUserId}
          rowClick={(record) =>
            window.open(`/admin/bmc/${record.id}`, '_blank')
          }
          rowClickable
        />
      ),
    },
    {
      name: locales.admin.student,
      component: (
        <StudentLists
          byId={currentUserId}
          expandRowClick={(record) => {
            history.push(`/admin/bmc/${record.id}`);
          }}
          locales={locales}
          currentPage={pageNames.superAdmin}
        />
      ),
    },
  ];

  return (
    <Container
      locales={locales}
      title={`${locales.admin.superAdmin}: ${user?.current?.firstName} ${user?.current?.surname}`}
    >
      <div className="admin-header-button__row">
        <h1>{locales.admin.superAdminDashboard}</h1>
        <ButtonReport
          href={downloadButtonParams.href}
          fileName={downloadButtonParams.fileName}
        >
          {locales.admin.downloadReport}
        </ButtonReport>
      </div>
      <BlockList list={collections} />
      <br />
      <br />

      {currentUserId && <Tabs tabs={tabItems} />}
    </Container>
  );
}
